module.exports = __webpack_public_path__ + "img/management.53fd3180.svg";